// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-renderer {
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.6;
  color: var(--text-primary);
  display: flow-root;
}

.markdown-content {
  font-size: 14px;
}

.html-content {
  font-size: 14px;
}

/* <center> in the html-content (DOMPurify) path */
.markdown-renderer.html-content center {
  display: block;
  text-align: center;
}

/* <center> in the markdown-content path (e.g. unclosed/stray tags that slip through sanitisation) */
.markdown-renderer.markdown-content center {
  display: block;
  text-align: center;
}

/* Explicitly center block children of <center> to beat any specificity conflicts */
.markdown-renderer center p,
.markdown-renderer center h1,
.markdown-renderer center h2,
.markdown-renderer center h3,
.markdown-renderer center h4,
.markdown-renderer center h5,
.markdown-renderer center h6 {
  text-align: center;
}

/* HTML align attribute on any block element (<div align="center">, <p align="right">, etc.) */
.markdown-renderer [align="center"] {
  text-align: center;
}
.markdown-renderer [align="right"] {
  text-align: right;
}
.markdown-renderer [align="left"] {
  text-align: left;
}

/* Headings */
.markdown-renderer h1,
.markdown-renderer h2,
.markdown-renderer h3,
.markdown-renderer h4,
.markdown-renderer h5,
.markdown-renderer h6 {
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: 700;
  color: var(--text-primary);
}

.markdown-renderer h1 {
  font-size: 24px;
}

.markdown-renderer h2 {
  font-size: 20px;
}

.markdown-renderer h3 {
  font-size: 18px;
}

.markdown-renderer h4 {
  font-size: 16px;
}

.markdown-renderer h5 {
  font-size: 14px;
}

.markdown-renderer h6 {
  font-size: 12px;
}

/* Paragraphs */
.markdown-renderer p {
  margin: 8px 0;
  line-height: 1.6;
  font-size: 1rem;
}

/* Links */
.markdown-renderer a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.2s;
}

.markdown-renderer a:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

/* Lists */
.markdown-renderer ul,
.markdown-renderer ol {
  margin: 8px 0 8px 16px;
  padding: 0;
}

.markdown-renderer li {
  margin: 4px 0;
}

/* Code */
.markdown-renderer .inline-code {
  background: var(--bg-secondary);
  color: var(--accent-primary);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.markdown-renderer .code-block {
  display: block;
  background: var(--bg-secondary);
  color: var(--text-primary);
  padding: 12px;
  border-radius: 8px;
  overflow-x: auto;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  margin: 8px 0;
}

.markdown-renderer pre {
  background: var(--bg-secondary);
  padding: 12px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 8px 0;
}

/* Blockquote */
.markdown-renderer .markdown-blockquote {
  border-left: 4px solid var(--accent-primary);
  padding-left: 12px;
  margin: 8px 0;
  color: var(--text-secondary);
  font-style: italic;
}

.markdown-renderer .markdown-spoiler {
  border: 1px dashed var(--border-color);
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 0;
  background: var(--bg-secondary);
}

.markdown-renderer .markdown-spoiler summary {
  cursor: pointer;
  font-weight: 600;
  color: var(--text-primary);
}

.markdown-renderer .markdown-spoiler div {
  margin-top: 8px;
  color: var(--text-primary);
}

/* Images */
.markdown-renderer img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 8px 0;
  display: block;
  float: none;
}

.markdown-renderer img[align='right'] {
  float: none;
  margin-left: auto;
  margin-right: 0;
}

.markdown-renderer img[align='center'] {
  float: none;
  margin-left: auto;
  margin-right: auto;
}

.markdown-renderer img[align='left'] {
  float: none;
  margin-left: 0;
  margin-right: auto;
}

.markdown-renderer .inline-image-placeholder {
  display: block;
  margin: 8px 0;
  padding: 8px 10px;
  border-left: 3px solid var(--accent-primary);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.88rem;
  border-radius: 6px;
}

.markdown-renderer .snap-image-grid {
  display: grid;
  gap: 6px;
  margin: 8px 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.markdown-renderer .snap-image-grid-3,
.markdown-renderer .snap-image-grid-5,
.markdown-renderer .snap-image-grid-6 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.markdown-renderer .snap-grid-item {
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  background: var(--bg-secondary);
}

.markdown-renderer .snap-image-grid .snap-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  display: block;
  margin: 0;
  border-radius: 0;
}

video {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.markdown-renderer .markdown-direct-video {
  display: block;
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  margin: 8px 0;
  background: #000;
}

.markdown-renderer .content-media-separator {
  margin-top: 16px;
  margin-bottom: 10px;
  padding-top: 10px;
  border-top: 2px dashed var(--border-color);
}

.markdown-renderer .content-media-separator span {
  display: inline-block;
  font-size: 0.82rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--text-secondary);
  background: var(--bg-primary);
  padding: 2px 8px;
}

/* Tables */
.table-wrapper {
  overflow-x: auto;
  margin: 12px 0;
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.markdown-renderer .markdown-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-secondary);
}

.markdown-renderer .markdown-table th {
  background: var(--hover-bg);
  padding: 10px;
  text-align: left;
  font-weight: 700;
  color: var(--text-primary);
  border-bottom: 2px solid var(--border-color);
}

.markdown-renderer .markdown-table td {
  padding: 10px;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
}

.markdown-renderer .markdown-table tbody tr:hover {
  background: var(--hover-bg);
}

/* Strikethrough (GFM) */
.markdown-renderer del {
  text-decoration: line-through;
  color: var(--text-secondary);
}

/* Task lists (GFM) */
.markdown-renderer input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
}

.markdown-renderer li > input[type="checkbox"] {
  margin-right: 8px;
}

/* Horizontal rule */
.markdown-renderer hr {
  border: none;
  height: 1px;
  background: var(--border-color);
  margin: 12px 0;
}

/* Strong and emphasis */
.markdown-renderer strong {
  font-weight: 700;
}

.markdown-renderer em {
  font-style: italic;
}

.markdown-renderer .text-left {
  text-align: left;
}

.markdown-renderer .text-center {
  text-align: center;
}

.markdown-renderer .text-right {
  text-align: right;
}

.markdown-renderer .shortapp-align.text-center img,
.markdown-renderer .shortapp-align.text-center .video-embed-wrapper,
.markdown-renderer .shortapp-align.text-center .table-wrapper,
.markdown-renderer .shortapp-align.text-center .markdown-spoiler,
.markdown-renderer .shortapp-align.text-center blockquote {
  margin-left: auto;
  margin-right: auto;
}

/* Center images and placeholders inside any native <center> element or
   any element that carries align="center" (e.g. <div align="center">).
   These are fallback paths for content that bypasses the shortapp-align
   conversion (e.g. <center> with attributes, or pass-through sanitised HTML). */
.markdown-renderer center img,
.markdown-renderer [align="center"] img {
  display: inline-block;
  margin: 0 4px;
  vertical-align: middle;
}

.markdown-renderer .shortapp-align.text-center img {
  display: inline-block;
  margin: 0 4px;
  vertical-align: middle;
}

/* Auto-detected image-only divs (e.g. actifit badge rows) also get .text-center
   without .shortapp-align — apply the same inline treatment. */
.markdown-renderer .text-center img {
  display: inline-block;
  margin: 0 4px;
  vertical-align: middle;
}

/* Carousel-mode image placeholders (display:block spans) need explicit auto
   margins + width:max-content so they are not 100%-wide and can centre. */
.markdown-renderer .shortapp-align.text-center .inline-image-placeholder,
.markdown-renderer center .inline-image-placeholder,
.markdown-renderer [align="center"] .inline-image-placeholder {
  width: max-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.markdown-renderer .shortapp-align.text-right img,
.markdown-renderer .shortapp-align.text-right .video-embed-wrapper,
.markdown-renderer .shortapp-align.text-right .table-wrapper,
.markdown-renderer .shortapp-align.text-right .markdown-spoiler,
.markdown-renderer .shortapp-align.text-right blockquote {
  margin-left: auto;
  margin-right: 0;
}

.markdown-renderer .shortapp-align.text-left img,
.markdown-renderer .shortapp-align.text-left .video-embed-wrapper,
.markdown-renderer .shortapp-align.text-left .table-wrapper,
.markdown-renderer .shortapp-align.text-left .markdown-spoiler,
.markdown-renderer .shortapp-align.text-left blockquote {
  margin-left: 0;
  margin-right: auto;
}

/* Video embeds */
.video-embed-wrapper {
  margin: 12px 0;
  width: 100%;
  max-width: 100%;
}

.video-embed-title {
  margin-bottom: 8px;
  font-weight: 600;
  color: var(--text-primary);
}

.video-embed-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  border-radius: 8px;
  overflow: hidden;
  background: #000;
}

.video-embed-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
}

@media (max-width: 768px) {
  .markdown-renderer .snap-image-grid-3,
  .markdown-renderer .snap-image-grid-5,
  .markdown-renderer .snap-image-grid-6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .video-embed-wrapper {
    margin: 10px 0;
  }

  .video-embed-container {
    padding-bottom: 56.25%;
  }
}

.markdown-renderer u {
  text-decoration: underline;
}

/* Embedded Hive posts */
.embedded-post {
  margin: 12px 0;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  transition: all 0.2s ease;
}

.embedded-post:hover {
  background: var(--hover-bg);
  border-color: var(--accent-color);
}

.embedded-post.loading,
.embedded-post.error {
  padding: 16px;
  text-align: center;
}

.embedded-post-loading {
  color: var(--text-secondary);
  font-style: italic;
}

.embedded-post-error {
  color: var(--error-color, #e74c3c);
  font-size: 13px;
}

.embedded-post-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.embedded-author {
  font-weight: 600;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 14px;
}

.embedded-author:hover {
  color: var(--accent-color);
}

.embedded-post-content {
  margin: 8px 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.embedded-post-content .markdown-renderer {
  font-size: 13px;
}

.embedded-post-link {
  display: inline-block;
  margin-top: 8px;
  font-size: 13px;
  color: var(--accent-color);
  text-decoration: none;
  font-weight: 500;
}

.embedded-post-link:hover {
  text-decoration: underline;
}

/* Short post links (for threads/comments, not long-form articles) */
.short-post-link {
  color: var(--accent-color);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.short-post-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/MarkdownRenderer/MarkdownRenderer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,oGAAoG;AACpG;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;;;;;;;EAOE,kBAAkB;AACpB;;AAEA,8FAA8F;AAC9F;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;;;;;;EAME,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,UAAU;AACV;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,gDAAgD;AAClD;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;gFAGgF;AAChF;;EAEE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;+DAC+D;AAC/D;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;0EAC0E;AAC1E;;;EAGE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB,EAAE,SAAS;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE;;;IAGE,gDAAgD;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".markdown-renderer {\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  line-height: 1.6;\r\n  color: var(--text-primary);\r\n  display: flow-root;\r\n}\r\n\r\n.markdown-content {\r\n  font-size: 14px;\r\n}\r\n\r\n.html-content {\r\n  font-size: 14px;\r\n}\r\n\r\n/* <center> in the html-content (DOMPurify) path */\r\n.markdown-renderer.html-content center {\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n/* <center> in the markdown-content path (e.g. unclosed/stray tags that slip through sanitisation) */\r\n.markdown-renderer.markdown-content center {\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n/* Explicitly center block children of <center> to beat any specificity conflicts */\r\n.markdown-renderer center p,\r\n.markdown-renderer center h1,\r\n.markdown-renderer center h2,\r\n.markdown-renderer center h3,\r\n.markdown-renderer center h4,\r\n.markdown-renderer center h5,\r\n.markdown-renderer center h6 {\r\n  text-align: center;\r\n}\r\n\r\n/* HTML align attribute on any block element (<div align=\"center\">, <p align=\"right\">, etc.) */\r\n.markdown-renderer [align=\"center\"] {\r\n  text-align: center;\r\n}\r\n.markdown-renderer [align=\"right\"] {\r\n  text-align: right;\r\n}\r\n.markdown-renderer [align=\"left\"] {\r\n  text-align: left;\r\n}\r\n\r\n/* Headings */\r\n.markdown-renderer h1,\r\n.markdown-renderer h2,\r\n.markdown-renderer h3,\r\n.markdown-renderer h4,\r\n.markdown-renderer h5,\r\n.markdown-renderer h6 {\r\n  margin-top: 12px;\r\n  margin-bottom: 8px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.markdown-renderer h1 {\r\n  font-size: 24px;\r\n}\r\n\r\n.markdown-renderer h2 {\r\n  font-size: 20px;\r\n}\r\n\r\n.markdown-renderer h3 {\r\n  font-size: 18px;\r\n}\r\n\r\n.markdown-renderer h4 {\r\n  font-size: 16px;\r\n}\r\n\r\n.markdown-renderer h5 {\r\n  font-size: 14px;\r\n}\r\n\r\n.markdown-renderer h6 {\r\n  font-size: 12px;\r\n}\r\n\r\n/* Paragraphs */\r\n.markdown-renderer p {\r\n  margin: 8px 0;\r\n  line-height: 1.6;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Links */\r\n.markdown-renderer a {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.markdown-renderer a:hover {\r\n  color: var(--primary-hover);\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Lists */\r\n.markdown-renderer ul,\r\n.markdown-renderer ol {\r\n  margin: 8px 0 8px 16px;\r\n  padding: 0;\r\n}\r\n\r\n.markdown-renderer li {\r\n  margin: 4px 0;\r\n}\r\n\r\n/* Code */\r\n.markdown-renderer .inline-code {\r\n  background: var(--bg-secondary);\r\n  color: var(--accent-primary);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 13px;\r\n}\r\n\r\n.markdown-renderer .code-block {\r\n  display: block;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  overflow-x: auto;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  margin: 8px 0;\r\n}\r\n\r\n.markdown-renderer pre {\r\n  background: var(--bg-secondary);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  overflow-x: auto;\r\n  margin: 8px 0;\r\n}\r\n\r\n/* Blockquote */\r\n.markdown-renderer .markdown-blockquote {\r\n  border-left: 4px solid var(--accent-primary);\r\n  padding-left: 12px;\r\n  margin: 8px 0;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n.markdown-renderer .markdown-spoiler {\r\n  border: 1px dashed var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  margin: 8px 0;\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.markdown-renderer .markdown-spoiler summary {\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.markdown-renderer .markdown-spoiler div {\r\n  margin-top: 8px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Images */\r\n.markdown-renderer img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin: 8px 0;\r\n  display: block;\r\n  float: none;\r\n}\r\n\r\n.markdown-renderer img[align='right'] {\r\n  float: none;\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n}\r\n\r\n.markdown-renderer img[align='center'] {\r\n  float: none;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.markdown-renderer img[align='left'] {\r\n  float: none;\r\n  margin-left: 0;\r\n  margin-right: auto;\r\n}\r\n\r\n.markdown-renderer .inline-image-placeholder {\r\n  display: block;\r\n  margin: 8px 0;\r\n  padding: 8px 10px;\r\n  border-left: 3px solid var(--accent-primary);\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  font-size: 0.88rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n.markdown-renderer .snap-image-grid {\r\n  display: grid;\r\n  gap: 6px;\r\n  margin: 8px 0;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n.markdown-renderer .snap-image-grid-3,\r\n.markdown-renderer .snap-image-grid-5,\r\n.markdown-renderer .snap-image-grid-6 {\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.markdown-renderer .snap-grid-item {\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.markdown-renderer .snap-image-grid .snap-image {\r\n  width: 100%;\r\n  aspect-ratio: 1 / 1;\r\n  object-fit: cover;\r\n  display: block;\r\n  margin: 0;\r\n  border-radius: 0;\r\n}\r\n\r\nvideo {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n.markdown-renderer .markdown-direct-video {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  border-radius: 8px;\r\n  margin: 8px 0;\r\n  background: #000;\r\n}\r\n\r\n.markdown-renderer .content-media-separator {\r\n  margin-top: 16px;\r\n  margin-bottom: 10px;\r\n  padding-top: 10px;\r\n  border-top: 2px dashed var(--border-color);\r\n}\r\n\r\n.markdown-renderer .content-media-separator span {\r\n  display: inline-block;\r\n  font-size: 0.82rem;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  color: var(--text-secondary);\r\n  background: var(--bg-primary);\r\n  padding: 2px 8px;\r\n}\r\n\r\n/* Tables */\r\n.table-wrapper {\r\n  overflow-x: auto;\r\n  margin: 12px 0;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.markdown-renderer .markdown-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.markdown-renderer .markdown-table th {\r\n  background: var(--hover-bg);\r\n  padding: 10px;\r\n  text-align: left;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.markdown-renderer .markdown-table td {\r\n  padding: 10px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.markdown-renderer .markdown-table tbody tr:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n/* Strikethrough (GFM) */\r\n.markdown-renderer del {\r\n  text-decoration: line-through;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Task lists (GFM) */\r\n.markdown-renderer input[type=\"checkbox\"] {\r\n  margin-right: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.markdown-renderer li > input[type=\"checkbox\"] {\r\n  margin-right: 8px;\r\n}\r\n\r\n/* Horizontal rule */\r\n.markdown-renderer hr {\r\n  border: none;\r\n  height: 1px;\r\n  background: var(--border-color);\r\n  margin: 12px 0;\r\n}\r\n\r\n/* Strong and emphasis */\r\n.markdown-renderer strong {\r\n  font-weight: 700;\r\n}\r\n\r\n.markdown-renderer em {\r\n  font-style: italic;\r\n}\r\n\r\n.markdown-renderer .text-left {\r\n  text-align: left;\r\n}\r\n\r\n.markdown-renderer .text-center {\r\n  text-align: center;\r\n}\r\n\r\n.markdown-renderer .text-right {\r\n  text-align: right;\r\n}\r\n\r\n.markdown-renderer .shortapp-align.text-center img,\r\n.markdown-renderer .shortapp-align.text-center .video-embed-wrapper,\r\n.markdown-renderer .shortapp-align.text-center .table-wrapper,\r\n.markdown-renderer .shortapp-align.text-center .markdown-spoiler,\r\n.markdown-renderer .shortapp-align.text-center blockquote {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* Center images and placeholders inside any native <center> element or\r\n   any element that carries align=\"center\" (e.g. <div align=\"center\">).\r\n   These are fallback paths for content that bypasses the shortapp-align\r\n   conversion (e.g. <center> with attributes, or pass-through sanitised HTML). */\r\n.markdown-renderer center img,\r\n.markdown-renderer [align=\"center\"] img {\r\n  display: inline-block;\r\n  margin: 0 4px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.markdown-renderer .shortapp-align.text-center img {\r\n  display: inline-block;\r\n  margin: 0 4px;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Auto-detected image-only divs (e.g. actifit badge rows) also get .text-center\r\n   without .shortapp-align — apply the same inline treatment. */\r\n.markdown-renderer .text-center img {\r\n  display: inline-block;\r\n  margin: 0 4px;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Carousel-mode image placeholders (display:block spans) need explicit auto\r\n   margins + width:max-content so they are not 100%-wide and can centre. */\r\n.markdown-renderer .shortapp-align.text-center .inline-image-placeholder,\r\n.markdown-renderer center .inline-image-placeholder,\r\n.markdown-renderer [align=\"center\"] .inline-image-placeholder {\r\n  width: max-content;\r\n  max-width: 100%;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.markdown-renderer .shortapp-align.text-right img,\r\n.markdown-renderer .shortapp-align.text-right .video-embed-wrapper,\r\n.markdown-renderer .shortapp-align.text-right .table-wrapper,\r\n.markdown-renderer .shortapp-align.text-right .markdown-spoiler,\r\n.markdown-renderer .shortapp-align.text-right blockquote {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n}\r\n\r\n.markdown-renderer .shortapp-align.text-left img,\r\n.markdown-renderer .shortapp-align.text-left .video-embed-wrapper,\r\n.markdown-renderer .shortapp-align.text-left .table-wrapper,\r\n.markdown-renderer .shortapp-align.text-left .markdown-spoiler,\r\n.markdown-renderer .shortapp-align.text-left blockquote {\r\n  margin-left: 0;\r\n  margin-right: auto;\r\n}\r\n\r\n/* Video embeds */\r\n.video-embed-wrapper {\r\n  margin: 12px 0;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.video-embed-title {\r\n  margin-bottom: 8px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.video-embed-container {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  padding-bottom: 56.25%; /* 16:9 */\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: #000;\r\n}\r\n\r\n.video-embed-container iframe {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n  border: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .markdown-renderer .snap-image-grid-3,\r\n  .markdown-renderer .snap-image-grid-5,\r\n  .markdown-renderer .snap-image-grid-6 {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .video-embed-wrapper {\r\n    margin: 10px 0;\r\n  }\r\n\r\n  .video-embed-container {\r\n    padding-bottom: 56.25%;\r\n  }\r\n}\r\n\r\n.markdown-renderer u {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Embedded Hive posts */\r\n.embedded-post {\r\n  margin: 12px 0;\r\n  padding: 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.embedded-post:hover {\r\n  background: var(--hover-bg);\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.embedded-post.loading,\r\n.embedded-post.error {\r\n  padding: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.embedded-post-loading {\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n.embedded-post-error {\r\n  color: var(--error-color, #e74c3c);\r\n  font-size: 13px;\r\n}\r\n\r\n.embedded-post-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.embedded-author {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  font-size: 14px;\r\n}\r\n\r\n.embedded-author:hover {\r\n  color: var(--accent-color);\r\n}\r\n\r\n.embedded-post-content {\r\n  margin: 8px 0;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.embedded-post-content .markdown-renderer {\r\n  font-size: 13px;\r\n}\r\n\r\n.embedded-post-link {\r\n  display: inline-block;\r\n  margin-top: 8px;\r\n  font-size: 13px;\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.embedded-post-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Short post links (for threads/comments, not long-form articles) */\r\n.short-post-link {\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.short-post-link:hover {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
